export const SET_USERNAME = 'SET_USERNAME';